<template>
  <div>
    Kanban by AIO
  </div>
</template>
<script>
import { Auth } from '@/core/utils/auth'

export default {
  name: 'login-page',
  methods: {
    encodeDataToURL (data) {
      return Object
        .keys(data)
        .map(value => `${value}=${encodeURIComponent(data[value])}`)
        .join('&')
    },
    // getTokenFromParams () {
    //   const parsedParams = {}
    //   this.$route.hash.split('&')
    //   .map(part => part.replace(/#/, ''))
    //   .forEach(param => {
    //     const parts = param.split('=')
    //     parsedParams[parts[0]] = parts[1]
    //   })
    //   return parsedParams['id_token']
    // },
  },
  mounted () {
    if (!_.isEmpty(this.$route.hash)) {
      // console.log('> LOGED')
    } else {
      let params = {redirect_uri: window.location.href,
                    client_id: process.env.VUE_APP_AIO_CONNECT_CLIENT_ID,
                    response_type: 'id_token',
                    nonce: 'waluigithewinner'}
      window.location = process.env.VUE_APP_AIO_CONNECT_URL + 'auth?' + this.encodeDataToURL(params)
    }
  }
  // eslint-disable-next-line
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/login/LoginPage.vue